/* eslint-disable react/destructuring-assignment */
import { MoreOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Dropdown, Popover, Tag } from "antd";
import { capitalize } from "lodash";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useBrowserExt from "../../../hooks/useBrowserExt";
import DownIcon from "../../../icons/DownIcon";
import FilterIcon from "../../../icons/js/FilterIcon";
import NotesIcon from "../../../icons/js/LeadProfileIcons/NotesIcon";
import { TaskAddIcon } from "../../../icons/js/LeadProfileIcons/TaskListIcon";
import { changeMessageOpportunity, setSelectedLeadRedux } from "../../../redux/slices/leadSlice";
import { NotesDrawer } from "./NotesDrawer";
import { statusColor } from "./engagementHelpers";
import LeadFilterBreadcrumbs from "./leadFilterBreadcrumbs";
import TranslateIcon from "../../../icons/js/LeadProfileIcons/TranslateIcon";
import { TranslationSettings } from "./TranslationSettings";
import { TaskDrawer } from "./TaskDrawer";
import { checkAccessPermission } from "../../../library/helpers";
import { AccessPermissionAction } from "../../../library/constants";

const TopToolbarJsx = props => {
  const {
    selectedLead,
    messageFilters,
    setMessageFilters,
    opportunityList,
    activeOpp,
    setActiveOpp,
    handleOppFilter,
    activeOppName,
  } = props;
  const { isBrowserExt } = useBrowserExt();
  const dispatch = useDispatch();
  const { messageOpportunity } = useSelector(state => state.lead);
  const setSelectedLead = lead => {
    dispatch(setSelectedLeadRedux(lead));
  };
  const [leadNotesData, setleadNotesData] = useState({
    open: false,
    leadNote: null,
    selectedLead: null,
    mode: "",
  });
  const [leadTaskData, setleadTaskData] = useState({
    open: false,
    leadTask: null,
    selectedLead: null,
    mode: "",
  });
  const selectedOpportunity = useMemo(() => {
    return opportunityList.find(item => String(item.id) === String(messageOpportunity));
  }, [messageOpportunity, selectedLead, opportunityList]);

  const fullOpportunity = (selectedLead?.leadOpportunities || [])?.find(
    item => +item.id === +selectedOpportunity?.id
  );
  const addTask = () =>
    setleadTaskData({
      ...leadTaskData,
      open: true,
      selectedLead,
      mode: "ADD",
    });
  const addNote = () =>
    setleadNotesData({ ...leadNotesData, open: true, selectedLead, mode: "ADD" });

  const canAddTask = checkAccessPermission(AccessPermissionAction.TASK_MANAGEMENT_ADD_EDIT);

  return (
    <div className="sm:px-4 sm:py-2 px-2 py-1 flex-row-centered justify-between">
      <div className="flex-row-centered items-center">
        <Dropdown
          trigger="click"
          menu={{
            items: (opportunityList || []).map(item => ({
              label:
                item.name === "All"
                  ? item.name
                  : `${item.name} #${item.opprId} - ${item.opprStatus}  `,
              key: item.id,
            })),
            onClick: e => dispatch(changeMessageOpportunity(e.key)),
          }}
        >
          <span className="flex-row-centered gap-1 items-center cursor-pointer">
            <span className="text-sm font-[600]">
              {selectedOpportunity?.name === "All"
                ? `${selectedOpportunity?.name}`
                : `${selectedOpportunity?.name} - #${selectedOpportunity?.opprId || ""}`}
            </span>
            <DownIcon />
          </span>
        </Dropdown>
        {(fullOpportunity?.opportunityStatus?.name || selectedLead?.leadStatusType?.type) && (
          <Tag
            className={`text-sm ${statusColor(
              fullOpportunity?.opportunityStatus?.name || selectedLead?.leadStatusType?.type,
              "class"
            )}`}
          >
            {capitalize(
              fullOpportunity?.opportunityStatus?.name || selectedLead?.leadStatusType?.type || ""
            )}
          </Tag>
        )}
      </div>
      {isBrowserExt ? (
        <div className="flex-row-centered gap-4 ">
          <Dropdown
            menu={{
              items: [
                {
                  label: (
                    <span onClick={addTask} className="flex-row-centered gap-1">
                      <TaskAddIcon /> Add task
                    </span>
                  ),
                  disabled: !canAddTask,
                },
                {
                  label: (
                    <span onClick={addNote} className="flex-row-centered gap-1">
                      <NotesIcon /> Add Note
                    </span>
                  ),
                },
              ],
            }}
          >
            <PlusCircleOutlined className="text-grey-500 cursor-pointer" />
          </Dropdown>
          <Popover
            open={props.visibleTranslationSettings}
            onOpenChange={() => {
              props.setVisibleTranslationSetting(!props.visibleTranslationSettings);
            }}
            trigger="click"
            content={<TranslationSettings {...props} />}
          >
            <TranslateIcon
              className="cursor-pointer"
              onClick={() => props.setVisibleTranslationSetting(!props.visibleTranslationSettings)}
            />
          </Popover>
          <Popover
            trigger="click"
            content={
              <LeadFilterBreadcrumbs
                filters={messageFilters}
                setFilters={payload => {
                  // props.page = 1;
                  setMessageFilters({ ...payload, page: 1 });
                }}
                opportunityList={opportunityList}
                activeOpp={activeOpp}
                setActiveOpp={setActiveOpp}
                handleOppFilter={handleOppFilter}
                activeOppName={activeOppName}
                isFilterBreadcrumbs
              />
            }
          >
            <FilterIcon className="cursor-pointer" />
          </Popover>
        </div>
      ) : (
        <div className="flex-row-centered gap-1 items-center">
          <Button
            onClick={addTask}
            disabled={!canAddTask}
            className="flex-row-centered gap-1 items-center"
          >
            <TaskAddIcon />
            Add Task
          </Button>
          <Button onClick={addNote} className="flex-row-centered gap-1 items-center">
            <NotesIcon /> Add Note
          </Button>
          <Popover
            trigger="click"
            content={
              <LeadFilterBreadcrumbs
                filters={messageFilters}
                setFilters={payload => {
                  // props.page = 1;
                  setMessageFilters({ ...payload, page: 1 });
                }}
                opportunityList={opportunityList}
                activeOpp={activeOpp}
                setActiveOpp={setActiveOpp}
                handleOppFilter={handleOppFilter}
                activeOppName={activeOppName}
                isFilterBreadcrumbs
              />
            }
          >
            <Button className="flex-row-centered gap-1 px-1.5 items-center">
              <FilterIcon />
            </Button>
          </Popover>
          <Button className="flex-row-centered gap-1 px-2 items-center">
            <MoreOutlined />
          </Button>
        </div>
      )}
      <NotesDrawer
        setSelectedLead={setSelectedLead}
        leadNotesData={leadNotesData}
        setleadNotesData={setleadNotesData}
      />
      <TaskDrawer
        setSelectedLead={setSelectedLead}
        leadTaskData={leadTaskData}
        setleadTaskData={setleadTaskData}
      />
    </div>
  );
};

export default TopToolbarJsx;
